<template>
  <div class="case-cover-upload" :aria-busy="reading">
    <case-cover :value="value" :alt="name + '封面预览'" size="preview" />
    <div class="case-cover-upload-controls">
      <input ref="file" class="case-cover-file" type="file" accept="image/png,image/jpeg" aria-label="选择案例封面图片" :disabled="disabled || reading" @change="select">
      <div class="lab-button-row">
        <button type="button" class="btn small" :disabled="disabled || reading" @click="$refs.file.click()">{{ reading ? '正在读取…' : value ? '更换图片' : '上传图片' }}</button>
        <button v-if="value" type="button" class="btn small lab-danger" :disabled="disabled || reading" @click="remove">移除封面</button>
      </div>
      <p class="lab-hint">支持 JPG、PNG，最大 2MB。{{ disabled ? '当前案例只读。' : '保存案例后生效。' }}</p>
      <p v-if="error" class="case-cover-error" role="alert">{{ error }}</p>
    </div>
  </div>
</template>
<script>
import CaseCover from './CaseCover.vue'
import { readCaseCover } from '../services/caseCover'
export default {
  name: 'CaseCoverUpload', components: { CaseCover },
  props: { value: String, name: { type: String, default: '案例' }, disabled: Boolean },
  data () { return { reading: false, error: '', generation: 0, disposed: false } },
  beforeDestroy () { this.disposed = true; this.generation++; this.$emit('busy', false) },
  methods: {
    async select (event) {
      const file = event.target.files && event.target.files[0]
      event.target.value = ''
      if (!file || this.disabled || this.reading) return
      const generation = ++this.generation
      this.error = ''; this.reading = true; this.$emit('busy', true)
      try {
        const value = await readCaseCover(file)
        if (!this.disposed && generation === this.generation && !this.disabled) this.$emit('input', value)
      } catch (e) { if (!this.disposed && generation === this.generation) this.error = e.message || '图片读取失败，请重新选择。' } finally {
        if (!this.disposed && generation === this.generation) { this.reading = false; this.$emit('busy', false) }
      }
    },
    remove () { if (this.disabled || this.reading) return; this.generation++; this.error = ''; this.$emit('input', '') }
  }
}
</script>
